/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {CHECKBOX_DIRECTIVES} from './checkbox/index';
export class ClrFormsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{imports: [CommonModule], declarations: [CHECKBOX_DIRECTIVES], exports: [CHECKBOX_DIRECTIVES]}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ClrFormsModule_tsickle_Closure_declarations() {
/** @type {?} */
ClrFormsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ClrFormsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
